import { useQuery } from "react-query";
import DashboardApiClient from "api/DashboardApiClient";

export function useGetSportsmanData(sportsmanId) {
    return useQuery(["sportsmanInfo", sportsmanId], () =>
        DashboardApiClient.getSportsmanData(sportsmanId),
    );
}
